import filter from "lodash/fp/filter";
import remove from "lodash/fp/remove";
import flow from "lodash/fp/flow";
import isNil from "lodash/fp/isNil";
import identity from "lodash/fp/identity";
class ListAction {
  constructor() {
    return this.transform;
  }

  transform(actions, item, filterName) {
    if (filterName === "bookingAction") {
      const status = item.status;
      const paid = item.paid ? "paid" : null;

      const removePay = (action) => action.name === "pay" && paid;
      const findByStrict = (action) => {
        return action.strict && action.strict.indexOf(status) > -1;
      };
      return flow([filter(findByStrict), remove(removePay)])(actions);
    } else if (filterName === "captainInvoiceAction") {
      const captainHasInvoice = item.hasInvoice;
      const hasInvoice = (action) =>
        action.name === "createInvoice" && captainHasInvoice;

      return flow([remove(hasInvoice), identity])(actions);
    } else if (filterName === "invoiceItemAction") {
      const isActive = item.active;
      const removeActivate = (action) =>
        action.name === "activateInvoiceItem" && isActive;
      const removeDeactivate = (action) =>
        action.name === "deactivateInvoiceItem" && !isActive;

      return flow([remove(removeActivate), remove(removeDeactivate)])(actions);
    } else if (filterName === "corporateInvoiceItemActions") {
      const isActive = item.active;
      const invoiceStatus = isNil(item.invoiceStatus)
        ? null
        : item.invoiceStatus;
      const isFinalInvoiceStatus =
        !isNil(invoiceStatus) && invoiceStatus === "final";
      const removeActivate = (action) =>
        action.name === "activateCorporateInvoiceItem" &&
        (isActive || isFinalInvoiceStatus);
      const removeDeactivate = (action) =>
        action.name === "deactivateCorporateInvoiceItem" &&
        (!isActive || isFinalInvoiceStatus);

      return flow([remove(removeActivate), remove(removeDeactivate)])(actions);
    }
    return actions;
  }
}

const ListActionFnc = () => new ListAction();

export default ListActionFnc;



// WEBPACK FOOTER //
// ./src/filters/listAction/listAction.filter.js